<template>
  <div id="myProfileView">
    <h1>{{ $t('privatePage.my_profile_header') }}</h1>
    <my-profile-editor :current-user="currentUser"
                       :company="userCompany"
                       :languages="languages"
                       ref="myProfileForm"
                       v-on:formSubmitted="formSubmitted">
    </my-profile-editor>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import MyProfileEditor from '../../components/users/myprofileeditor'

export default {
  components: {
    MyProfileEditor
  },
  computed: {
    ...mapGetters([
      'hasSupplierPermissions',
      'hasResellerPermissions',
      'hasCustomerPermissions',
      'languages'
    ]),
    ...mapGetters('userGroupsModule', [
      'currentGroup',
      'defaultResellerGroupId',
      'defaultCustomerTypeId',
      'defaultCustomerTypeName',
      'userCompany'
    ])
  },
  data() {
    return {
      currentUser: {}
    }
  },
  methods: {
    ...mapActions({
      getLanguages: 'getLanguages',
      showSuccessMessage: 'showSuccessMessage',
      showErrorMessage: 'showErrorMessage',
      setSelectedCulture: 'setSelectedCulture'
    }),
    ...mapActions('userGroupsModule', {
      getMyCustomerGroups: 'getMyCustomerGroups',
      selectGroup: 'selectGroup',
      deleteUser: 'deleteUser',
      addUser: 'addUser',
      updateUser: 'updateUser',
      getMyResellerGroups: 'getMyResellerGroups',
      getUser: 'getUser'
    }),
    formSubmitted: function(user) {
      this.updateUser({
        currentUser: user,
        newUser: user
      })
        .then(result => {
          if (result.ok === true) {
            let cultures = this.languages.filter(
              l => l.languageId === user.languageId
            )

            if (cultures.length === 1) {
              this.$root.$i18n.locale = cultures[0].langCode
              this.setSelectedCulture(cultures[0]).then(() => {
                this.showSuccessMessage(this.$t('save_ok_feedback'))
              })
            }
          } else {
            this.showErrorMessage(result.message)
          }
        })
        .catch(() => {})
    }
  },
  created() {
    this.getUser().then(user => {
      this.currentUser = user
    })
  }
}
</script>
